// extracted by mini-css-extract-plugin
export default {"popover":"GVGMveThPWOSD1UOk3V1","cover":"mUKm6bp6GHBn5mkLTH9j","color":"hOaFIy_0IXy4iBOvpoGx"};